import type { ImportType, ImportTypeConfig } from "@/types/bulk-upload-types";

const EXPERT_TAGS_EXAMPLE_CSV_CONTENT = `Use Cases,Integrations,Specific Platform Features or Add-Ons,Competitive Displacement,Expertise Level,Experience
Marketing,Salesforce,Meeting Reminders,Calendly,Beginner,1-3 years
ABM,HubSpot,After Meeting Workflows,Chili Piper,Expert,3+
Sales,Ringcentral,Custom Tags,Manual Process,Thought Leader,5-7 years
Top of Funnel,Fathom,Automatic Payouts,Cloud,Intermediate,
Reference Management,Zapier,Profile Sync,Manifest,Pro,
,Marketo,wesle,yep,Ascended,
,Klaviyo,test,,Wood,
,Shopify,mustard,,,
,asfas,hot dog,,,
,integration 1,nope,,,
,gathering,magic,,,
,mh2,mh3,,,
,horizons,grand abolisher,,,
,,nut collector,,,
,,fasfasfafa,,,`;

const SHORTLISTED_EXPERTS_EXAMPLE_CSV_CONTENT = `First Name,Last Name,Email,LinkedIn URL,Title,Company,Source
John,Doe,john.doe@example.com,https://linkedin.com/in/johndoe,Senior Software Engineer,Tech Corp,Referral
Jane,Smith,jane.smith@example.com,https://linkedin.com/in/janesmith,Product Manager,StartupX,Direct
Michael,Johnson,michael.j@example.com,https://linkedin.com/in/michaeljohnson,VP of Engineering,Innovation Labs,LinkedIn`;

export const IMPORT_TYPE_CONFIGS: Record<ImportType, ImportTypeConfig> = {
  shortlisted_experts: {
    type: "shortlisted_experts",
    title: "Bulk Upload Shortlisted Experts",
    description: "Upload a CSV file with shortlisted experts. ",
    exampleCsvFileName: "shortlisted-experts-example.csv",
    exampleCsvContent: SHORTLISTED_EXPERTS_EXAMPLE_CSV_CONTENT,
  },

  tags_upload: {
    type: "tags_upload",
    title: "CSV Upload",
    description: "Upload a csv file with expert tags. ",
    exampleCsvFileName: "expert-tags-example.csv",
    exampleCsvContent: EXPERT_TAGS_EXAMPLE_CSV_CONTENT,
  },
};

export const getImportTypeConfig = (
  importType: ImportType
): ImportTypeConfig => {
  return IMPORT_TYPE_CONFIGS[importType];
};

export const getImportTypeLabel = (importType: ImportType): string => {
  return IMPORT_TYPE_CONFIGS[importType]?.title || importType;
};
